import React from 'react';

function VariantSelector({ variants, selectedVariant, onVariantChange }) {
  if (!variants || variants.length <= 1) return null;

  const getVariantDisplayName = (variant) => {
    if (variant.attributes ) {
      // If attributes exist, format them nicely
      const attributeValues = Object.values(variant.attributes).filter(val => val && val.toString().trim() !== '');
      if (attributeValues.length > 0) {
        return attributeValues.join(' - ');
      }
    }
    // Fallback to SKU if no attributes
    return variant.sku;
  };

  return (
    <div className="variant-selector mb-2">
      <label className="form-label">{window.gettext("Select Option")}:</label>
      <span className="select-wrap">
        <select 
          className="form-control" 
          value={selectedVariant?.sku || ''} 
          onChange={(e) => {
            const variant = variants.find(v => v.sku === e.target.value);
            onVariantChange(variant);
          }}
        >
          {variants.map(variant => (
            <option key={variant.sku} value={variant.sku}>
              {getVariantDisplayName(variant)}
            </option>
          ))}
        </select>
      </span>
    </div>
  );
}

export default VariantSelector; 